import React from 'react';

import { FormField, FormHelp, Label } from '@zillow/constellation';

import type { Section } from '../../../../models';
import { CONDO_ASSOCIATION_RULES } from '../../../../constants';
import YesAndNo from '../../../../../shared/components/Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function CondoAssociationRules_v2({ section, setSectionValues }: Props) {
  function onNoRules(): void {
    setSectionValues({
      [CONDO_ASSOCIATION_RULES.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesRules(): void {
    setSectionValues({
      [CONDO_ASSOCIATION_RULES.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <FormField
      label={<Label size="lg">Do any condo association rules apply to the property?</Label>}
      control={
        <YesAndNo
          yesHandler={onYesRules}
          noHandler={onNoRules}
          yesActive={section.getFieldValue(CONDO_ASSOCIATION_RULES.FIELD_NAME.IS_ENABLED)}
        />
      }
      description={
        section.getFieldValue(CONDO_ASSOCIATION_RULES.FIELD_NAME.IS_ENABLED) && (
          <FormHelp>
            You must provide the tenant copies of all condo association rules and regulations before the lease is signed
          </FormHelp>
        )
      }
    />
  );
}

CondoAssociationRules_v2.description = 'Condo association rules screen specific screen (not comingled with HOA rules)';
